import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeletePlayerInput_InputAdapter_instance1cxdu15t78vv8 as DeletePlayerInput_InputAdapter_instance } from '../type/adapter/DeletePlayerInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerMutation_VariablesAdapterClass;
function DeletePlayerMutation_VariablesAdapter() {
  if (DeletePlayerMutation_VariablesAdapterClass === VOID) {
    class $ {
      f6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.t48('input');
        obj(DeletePlayerInput_InputAdapter_instance).r40(writer, customScalarAdapters, value.e6h_1);
      }
    }
    initMetadataForObject($, 'DeletePlayerMutation_VariablesAdapter');
    DeletePlayerMutation_VariablesAdapterClass = $;
  }
  return DeletePlayerMutation_VariablesAdapterClass;
}
var DeletePlayerMutation_VariablesAdapter_instance;
function DeletePlayerMutation_VariablesAdapter_getInstance() {
  return DeletePlayerMutation_VariablesAdapter_instance;
}
//region block: init
DeletePlayerMutation_VariablesAdapter_instance = new (DeletePlayerMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  DeletePlayerMutation_VariablesAdapter_instance as DeletePlayerMutation_VariablesAdapter_instance2r7jk7yyecscn,
};
//endregion

//# sourceMappingURL=DeletePlayerMutation_VariablesAdapter.mjs.map
